// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_SettingsPage__45xRE{
  width: 100%;
  overflow: auto;
  align-items: center;
}

.styles_SS365accountSettings__jtVIc {
  min-width: min-content;
  width: 70%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  background-color: white;
}
.styles_FormRow__NAl52 {
  display: grid;
  grid-template-columns: 2fr 3fr 5fr 2fr;
  margin-top: 10px;
}

.styles_SettingsPage__45xRE input {
  padding: 5px;
  border-radius: 3px;
  border: 1px solid rgba(10, 10, 10, 0.3);
}
.styles_Notification__69Iyz {
  color: rgba(100, 200, 100, 0.8)
}
`, "",{"version":3,"sources":["webpack://./src/pages/SettingsPage/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE;AACF","sourcesContent":[".SettingsPage{\n  width: 100%;\n  overflow: auto;\n  align-items: center;\n}\n\n.SS365accountSettings {\n  min-width: min-content;\n  width: 70%;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 50px;\n  background-color: white;\n}\n.FormRow {\n  display: grid;\n  grid-template-columns: 2fr 3fr 5fr 2fr;\n  margin-top: 10px;\n}\n\n.SettingsPage input {\n  padding: 5px;\n  border-radius: 3px;\n  border: 1px solid rgba(10, 10, 10, 0.3);\n}\n.Notification {\n  color: rgba(100, 200, 100, 0.8)\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SettingsPage": `styles_SettingsPage__45xRE`,
	"SS365accountSettings": `styles_SS365accountSettings__jtVIc`,
	"FormRow": `styles_FormRow__NAl52`,
	"Notification": `styles_Notification__69Iyz`
};
export default ___CSS_LOADER_EXPORT___;
